<template>
<span>
  <quote-sign />
    <slot />
  <quote-sign end />
</span>
</template>
<script>
import QuoteSign from '@/components/landingPage/QuoteSign.vue'
export default {
  name: 'QuoteSlot',
  components: { QuoteSign }
}
</script>
<style lang="less" scoped>

</style>
